import './bottombar.scss'

const Bottombar = () => {
    const currentYear = new Date().getFullYear()
    return (
        <div className="bottombar">
            <div className="sections">
                <div className="section">
                    OLIVIA PEÑA RUE {currentYear}
                </div>
                <div className="section">
                    <a href="/"style={{textDecoration:"none", color:"black"}}>
                        HOME
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Bottombar